<template>  
<div> <!-- root element start -->
	<div class="row">
		<div class="col-12">
			<div class="card border-0">
			    <div class="card-header h5 bg-transparent border-0">Edit an Organization</div>

          <div v-if="loading == 0" class="card-body">
            <div class="row">
              <div class="col-12 mt-4">
                <scaling-squares-spinner :animation-duration="2000" :size="65" color="#0E1698" style="margin:auto"/>
              </div>
            </div>
          </div>

          <div v-if="loading == 1" class="card-body">

            <div class="row d-flex align-items-center mb-3">
              <div class="col-12 col-lg-2">
                <small>Title</small>
              </div>
              <div class="col-12 col-lg-8">
                <input type="text" class="form-control" placeholder="Organization Title" v-model="org_title">
              </div>
              
            </div>

            
            
          </div> <!-- end card body -->

          <div v-if="loading == 1" class="card-body border-top">
            <div class="row d-flex align-items-center mb-3">
              <div class="col-12 d-flex justify-content-between align-items-center">
                <span>
                  <button class="btn btn-warning" @click="cancelOrg">Cancel</button>
                  <button class="btn btn-success" @click="submitOrg">Save Organization</button>
                </span>
                <a href="#" @click="resetData">Reset</a>
              </div>
            </div>
          </div><!--  end card-body -->

			</div>
		</div>
	</div>
</div> <!-- root element end -->
</template>


<script>
import { ScalingSquaresSpinner } from 'epic-spinners'




export default {
  props: ['prop1', 'prop2', 'prop3'],
  data: function () {
    return { 
      loading: 0,
      origData: [],
      org_title: '',
    }
  },
  computed: {

  },
  watch: {
    
  },
  mounted() {
    this.getOrgInformation();
  },
  methods: {
    changeRightView(name, prop1, prop2, prop3) { this.$store.dispatch("getRightView", { name: name, prop1: prop1, prop2: prop2, prop3: prop3 }); },

    getOrgInformation() {
      var _this = this;
      _this.loading = 0;
      axios.get('/utility/user/org/getorgdetails/' + _this.prop3[2] )
        .then(function (response) {
          var a = response.data.data;
          _this.origData = a;
          _this.org_title = a.name;
          _this.loading = 1;
        })
        .catch(function (error) {
          var errors = error.response.data.errors;
          _this.errorDisplay(errors);
        })
    },
    
    resetData() {
      var _this = this;
      _this.org_title = _this.origData.name;
    },
    
    submitOrg() {
      var _this = this;
      _this.$toastr.warning('Validating organization information.', 'Please wait!')
      //validate with js
      var valErrors = [];
      //validate org title
      if(_this.org_title == '' || _this.org_title == null || _this.org_title.length < 3) { valErrors.push('A valid organization title of at least three characters is required!') }
      
      if(valErrors.length > 0) {
        _this.$toastr.remove();
        _this.errorDisplay(valErrors);
        return false;
      } 
      _this.$toastr.remove();
      
      _this.$toastr.warning('Saving new organization information.', 'Please wait!')
      axios.post('/utility/all/org/updateorgtitle', {
        org_id: _this.prop3[2],
        org_title: _this.org_title,
      })
        .then(function (response) {
          var msg = response.data.msg;
          _this.$toastr.remove()
          _this.$toastr.success(msg, 'Success!', {timeOut: 5000});
          _this.$emit('onSComplete', ['org-edit', response.data.newid])
        })
        .catch(function (error) {
          var errors = error.response.data.errors;
          _this.errorDisplay(errors);
        })

    },

    cancelOrg() {
      var _this = this;
      _this.$emit('onUComplete', ['org-edit'])
    },
    errorDisplay(valErrors) {
      var _this = this;
      var errors = valErrors;
      var errorsHTML = '<div class="alert alert-danger text-left"><strong>Please fix the following errors</strong><ul>';
      $.each(errors, function(key, value){ errorsHTML += '<li>' + value + '</li>' });
      errorsHTML += '</ul></div>';
      _this.$swal({ type: 'error', title: 'Problem!', html: errorsHTML, });
    },
  },    
  components:{
    ScalingSquaresSpinner,
    
  },
  filters: {

  }
}
</script>

